<template>
  <div class="h-auto ml-0 w-full lg:mr-3">
    <div
      class="flex flex-wrap lg:justify-start divide-x-1.5 bg-white mx-3 my-5 items-center"
    >
      <div
        v-for="(menu, index) in filteredTabs"
        :key="index"
        @click="setSelectedMenu(menu.name)"
        :class="{
          'bg-primary text-white': selectedSubMenu === menu.name,
        }"
        class="text-sm text-center font-semibold hover:bg-primary hover:text-white cursor-pointer p-3"
      >
        {{ menu.name }}
      </div>
    </div>
    <SinglePerformanceFlow
      :key="MineKey"
      v-if="selectedSubMenu == 'My Performance'"
    ></SinglePerformanceFlow>
    <TeamPerformance
      :key="TeamKey"
      v-if="selectedSubMenu == 'Team Performance'"
    ></TeamPerformance>
    <ContinuousFeedback
      :key="ConKey"
      v-if="selectedSubMenu == 'Continuous Feedback'"
    ></ContinuousFeedback>
    <Evaluation
      :key="EvalKey"
      v-if="selectedSubMenu == '360 Evaluation'"
    ></Evaluation>
    <MonthlyReview :key="MontKey" v-if="selectedSubMenu == 'Monthly Review'">
    </MonthlyReview>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PerformanceReview',
  components: {
    SinglePerformanceFlow: () =>
      import('@/components/PerformanceReview/SinglePerformanceFlow.vue'),
    TeamPerformance: () =>
      import('@/components/PerformanceReview/teamPerformance/ObjHome.vue'),
    ContinuousFeedback: () =>
      import('@/components/PerformanceReview/ContinuousFeedback.vue'),
    Evaluation: () =>
      import('@/components/PerformanceReview/360Evaluation.vue'),
    MonthlyReview: () =>
      import('@/components/PerformanceReview/MonthReview/MonthlyReview.vue'),
  },
  data() {
    return {
      selectedSubMenu: 'My Performance',
      MineKey: 0,
      TeamKey: 1,
      ConKey: 2,
      EvalKey: 3,
      MontKey: 4,
      subMenus: [
        {
          name: 'My Performance',
          route: 'MyPerformance',
        },
        // {
        //   name: "Monthly Review",
        //   route: "MonthlyReview"
        // },
        {
          name: 'Team Performance',
          route: 'TeamPerformance',
        },
        {
          name: '360 Evaluation',
          route: '360Evaluation',
        },
        /*{
          name: "Continuous Feedback",
          route: "ContinuousFeedback",
        },*/
      ],
    };
  },
  computed: {
    ...mapGetters(['getUserRole']),
    filteredTabs() {
      if (['hrmanager', 'manager'].includes(this.getUserRole.toLowerCase())) {
        return this.subMenus;
      } else {
        return this.subMenus.filter(
          (tab) => tab.name.trim() !== 'Team Performance',
        );
      }
    },
  },
  created() {
    this.subMenus.forEach((menu) => {
      if (menu.route == this.$route.params.type) {
        this.selectedSubMenu = menu.name;
      }
    });
  },
  watch: {
    $route(to) {
      this.subMenus.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
        }
      });
      switch (this.selectedSubMenu) {
        case 'My Performance':
          this.MineKey++;
          break;
        case 'Team Performance':
          this.TeamKey++;
          break;
        case 'Continuous Feedback':
          this.ConKey++;
          break;
        case '360 Evaluation':
          this.EvalKey++;
          break;
      }
    },
  },
  methods: {
    setSelectedMenu(menuName) {
      this.selectedSubMenu = menuName;
    },
  },
};
</script>
